// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectRiskWarningMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_RISK_WARN_MESSAGE)

    this.AccountID = null;
    this.Text = null;
    this.RiskRuleType = null;
    this.RiskWarnLevel = null;
}

DirectRiskWarningMessage.RiskRuleWarningHeader = "dealticket.RiskRuleWarning.Header";
DirectRiskWarningMessage.PositionLossLimitRiskRuleType = 10;
DirectRiskWarningMessage.LossLimitPerTrade = 12;

DirectRiskWarningMessage.prototype = Object.create(DirectMessageBase.prototype)